<template>
  <b-container>
    <Breadcrumbs crumbString="View Our Work,Oregon Islands NWR"></Breadcrumbs>
    <b-row>
      <b-col class="col-12 col-md-4 col-lg-4">
        <h2>{{ title }}</h2>
        <p>Interpretive Signs<br>
          Oregon Coast<br>
          DuraReader signs with stainless steel pedestals</p>
        <h4>Oregon Islands NWR Design Team</h4>
        <div>
          <p><img class="profile" src="../../../assets/images/john-peters.jpg">
            <strong>John Peters, President of Interpretive Graphics
            based in Salt Lake City, Utah and the team’s project
              manager and fabricator</strong>, is known for his high level of
            knowledge, competence, attention to detail, flexibility to meet
            client needs, and overall professionalism. Interpretive
            Graphics’ projects are found across the U.S. and beyond.
            Interpretive Graphics uses many signage materials and
            mounting systems and understands the advantages, limitations, and fabrication requirements of each,
            including both exterior graphic panels and interior exhibits. The company’s website (www.envirosigns.com)
            is a valued resource for clients, explaining process and fabrication methods. Prices are competitive and fair.
            John’s track record is stellar, and he will assure that this team project succeeds at every level to meet
            client expectations well beyond the duration of the contract.</p>
        </div>
        <div>
          <p><img class="profile" src="../../../assets/images/marina-richie.jpg">
            <strong>Marina Richie, Interpretive Planner and Writer,
              based in Bend, Oregon</strong>, brings a wealth of knowledge
            and ability to plan and write compelling and accurate
            textabout nature and culture. Her master’s degree in
            Journalism (University of Montana and undergraduate in
            Biology (University of Oregon) have proved an invaluable
            combination. As part of the Interpretive Graphics team from
            2016-2018, she served as interpretive planner, writer, and
            project manager for the Oregon Islands NWR large scale interpretive sign project. In a 2011-2015 position as
            the Communications Director for the Sage Grouse Initiative, she researched and wrote multiple pieces on wildlife,
            ranching, and sagebrush ecosystems. There, she also oversaw all communications for a fast-paced national
            partnership with multiple subcontractors, deadlines, and complexity. Her 30 + years of interpretive writing
            include exhibit panels, blogs, website content, national wildlife refuge brochures, radio scripts, children’s
            books on birds and bugs, magazine features, and museum exhibits.</p>
        </div>
        <div>
          <p><img class="profile" src="../../../assets/images/ram-papish.jpg">
            <strong>Ram Papish, Wildlife Artist and Photographer
              based in Newport, Oregon</strong>, fell in love with the open
            landscapes of Central Oregon while working for Lakeview
            Ranger District years ago. There he studied rangeland bird and
            plant associations and became familiar with the region’s
            wildlife. The next year he illustrated Birds of Malheur County.
            He has also illustrated regional books including Birds of Oregon, Pacific Northwest Birds in Winter and
            The Handbook of Oregon Birds. His 15 years of working as a biotech and field assistant has supplied Ram with
            an abundance of first-hand experience that comes across clearly in his illustrations and photography. Over
            the past 10 years he has contributed interpretive illustrations for almost 300 panels that include the recent Oregon Islands NWR project..</p>
        </div>
        <div>
          <p><img class="profile" src="../../../assets/images/maja-smith.jpg">
            <strong>Maja Smith, Graphic Designer based in Burlington,
              Vermont</strong>, brings 19 years of experience as graphic designer
            and art director, with a passion and concentration in
            interpretive media. Maja’s work inspires people to immerse
            themselves in new landscapes and cultures. Her intention as a
            designer is to help tell a story effectively and creatively through
            graphic elements and the fine composition of those elements. She works with writer Marina Richie and artist
            Ram Papish from the early stages of a project through its final touches. She strives to capture the sense of
            place of a region and to compose and convey that in her designs. Many of Maja’s projects have involved large
            volumes of panels and multiple products. For example, she designed 45 kiosk and wayside interpretive panels
            for Utah Scenic Byway 12, 94 kiosk and wayside interpretive panels for the Salt Lake City Open Space program,
            and most recently with the Interpretive Graphics team, 66 kiosk and wayside interpretive panels for Oregon
            Islands NWR. Maja has also designed interpretive exhibits for a variety of museums including a citizens’
            science lab for the ECHO - Leahy Center for Lake Champlain in Burlington, VT. There she designed a number of
            low-tech interactive displays encouraging citizens to take action in stewardship initiatives for Lake Champlain.
            Maja delights in the process of creating the necessary threads in design and messaging that unify both large
            and small assemblages of interpretive panels.</p>
        </div>
      </b-col>
      <b-col class="col-12 col-md-8 col-lg-8 image-slider-container">
        <ImageSlider :images="images" class="image-slider" :award="true"></ImageSlider>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import Breadcrumbs from '@/components/Breadcrumbs.vue'
  import ImageSlider from '@/components/ImageSlider.vue'

  export default {
    components: {
      Breadcrumbs,
      ImageSlider
    },
    props: {
      images: {
        default: () => [
          require('@/assets/images/pages/oregon/oregon-coast-wayside-signs01.jpg'),
          require('@/assets/images/pages/oregon/oregon-coast-wayside-signs02.jpg'),
          require('@/assets/images/pages/oregon/oregon-coast-wayside-signs03.jpg'),
          require('@/assets/images/pages/oregon/oregon-coast-wayside-signs04.jpg'),
          require('@/assets/images/pages/oregon/oregon-coast-wayside-signs05.jpg'),
          require('@/assets/images/pages/oregon/oregon-coast-wayside-signs06.jpg'),
          require('@/assets/images/pages/oregon/oregon-coast-wayside-signs07.jpg'),
          require('@/assets/images/pages/oregon/oregon-coast-wayside-signs08.jpg'),
          require('@/assets/images/pages/oregon/oregon-coast-wayside-signs09.jpg'),
          require('@/assets/images/pages/oregon/oregon-coast-wayside-signs10.jpg'),
          require('@/assets/images/pages/oregon/oregon-coast-wayside-signs11.jpg'),
          require('@/assets/images/pages/oregon/oregon-coast-wayside-signs12.jpg'),
          require('@/assets/images/pages/oregon/oregon-coast-wayside-signs13.jpg'),
          require('@/assets/images/pages/oregon/oregon-coast-wayside-signs14.jpg'),
          require('@/assets/images/pages/oregon/oregon-coast-wayside-signs15.jpg'),
          require('@/assets/images/pages/oregon/oregon-coast-wayside-signs16.jpg'),
          require('@/assets/images/pages/oregon/oregon-coast-wayside-signs17.jpg'),
          require('@/assets/images/pages/oregon/oregon-coast-wayside-signs18.jpg'),
          require('@/assets/images/pages/oregon/oregon-coast-wayside-signs19.jpg'),
          require('@/assets/images/pages/oregon/oregon-coast-wayside-signs20.jpg'),
          require('@/assets/images/pages/oregon/oregon-coast-wayside-signs21.jpg'),
          require('@/assets/images/pages/oregon/oregon-coast-wayside-signs22.jpg'),
          require('@/assets/images/pages/oregon/oregon-coast-wayside-signs23.jpg')
        ],
        type: Array
      }
    },

    data () {
      return {
        title: 'Oregon Islands NWR'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/viewOurWork/Oregon.vue